const pillars = [
  {
    key: "owned",
    title: "Built once, owned for life.",
    body:
      "We ship code to the operator's repository. No vendor lock-in, no rented seats, no licence ratchet at renewal — the systems we deliver are owned by the business that asked for them.",
  },
  {
    key: "senior",
    title: "Senior bench, on every engagement.",
    body:
      "Every engagement is led by senior engineers with years on the build. There is no junior pass-through; the people in the design review are the people writing the production code.",
  },
  {
    key: "horizon",
    title: "A five-year horizon, not five sprints.",
    body:
      "We accept scope we can defend for the lifetime of the system — typed code, automated tests, written architecture, observability shipped on day one. What we build is operable on the same calendar as a finance audit.",
  },
  {
    key: "fit",
    title: "Off-the-shelf, where it fits. Custom, where it doesn't.",
    body:
      "We do not start from the assumption that everything must be built. We start from the operator's process — and only build the part the catalogue does not cover. The integration layer is usually the work.",
  },
];

export default pillars;
